export const MAX_POST_LENGTH = 280
export const MICRO_USDC = 1_000_000
export const USDC_DECIMALS = 6

// DexScreener
export const DEXSCREENER_SOLANA_URL = "https://dexscreener.com/solana"

// Spotlight
export const SPOTLIGHT_DURATION_MS = 60 * 60 * 1000 // 1 hour
export const SPOTLIGHT_QUEUE_MAX = 24

// World ID — flip to false to hide all World ID entry points
export const WORLD_ID_ENABLED = true
export const WORLD_ID_ACTION = "free-posts-daily"
